import { PincodeData } from 'src';
import {
  testPincodePersonData,
  testPincodePersonVehicleDataPermite,
  testPincodePersonLeadDataPermite,
  testPincodePersonVehicleDataNoPermite,
  testPincodePersonLeadDataNoPermite,
  testPincodePersonVehiclePedidoDealerDataNoPermite,
  testPincodePersonVehiclePedidoDealerDataPermite,
} from '.';

export const checkIfIsTestPincode = (pincode: string) =>
  pincode === 'PINCODE-PERSON' ||
  pincode === 'PINCODE-PERSON-LEAD-PERMITE' ||
  pincode === 'PINCODE-PERSON-LEAD-NO-PERMITE' ||
  pincode === 'PINCODE-PERSON-VEHICLE-PERMITE' ||
  pincode === 'PINCODE-PERSON-VEHICLE-NO-PERMITE' ||
  pincode === 'PINCODE-PERSON-VEHICLE-ORDER-DEALER-PERMITE' ||
  pincode === 'PINCODE-PERSON-VEHICLE-ORDER-DEALER-NO-PERMITE';

export const getTestPincode = (pincode: string): PincodeData => {
  if (pincode === 'PINCODE-PERSON') {
    return testPincodePersonData;
  } else if (pincode === 'PINCODE-PERSON-LEAD-PERMITE') {
    return testPincodePersonLeadDataPermite;
  } else if (pincode === 'PINCODE-PERSON-LEAD-NO-PERMITE') {
    return testPincodePersonLeadDataNoPermite;
  } else if (pincode === 'PINCODE-PERSON-VEHICLE-PERMITE') {
    return testPincodePersonVehicleDataPermite;
  } else if (pincode === 'PINCODE-PERSON-VEHICLE-NO-PERMITE') {
    return testPincodePersonVehicleDataNoPermite;
  } else if (pincode === 'PINCODE-PERSON-VEHICLE-ORDER-DEALER-PERMITE') {
    return testPincodePersonVehiclePedidoDealerDataPermite;
  } else if (pincode === 'PINCODE-PERSON-VEHICLE-ORDER-DEALER-NO-PERMITE') {
    return testPincodePersonVehiclePedidoDealerDataNoPermite;
  }
  return null;
};
